import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './components/MainPage';
import AuthPage from './components/AuthPage';
import PunditWelcomePage from './components/PunditWelcomePage';
import ChatInterface from './components/ChatInterface';
import { getAuth } from 'firebase/auth';
import axios from 'axios';
import './App.css';
import RoundUpWelcomePage from './components/RoundUpWelcomePage';

const App: React.FC = () => {
    const [theme, setTheme] = useState<string>('dark');
    const [userId, setUserId] = useState<string | null>(null); // New state variable for user ID


    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = auth.onAuthStateChanged(async user => {
            if (user) {
                //console.log("User: ", user);  // Log the user
                // const token = await user.getIdToken(true);
                //console.log("Token: ", token);  // Log the token
                setUserId(user.uid);  // Update the user ID
                console.log('User is signed in');
            } else {
                setUserId(null);  // Reset the user ID if logged out
                console.log('No user is signed in');
            }
        });

        console.log('Current NODE_ENV:', process.env.NODE_ENV);

        loadTheme(theme);

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [theme]);

    const loadTheme = (themeName: string) => {
        const linkElement = document.getElementById('theme-style') as HTMLLinkElement;
        if (!linkElement) {
            // Create a new link element if it doesn't exist
            const newLinkElement = document.createElement('link');
            newLinkElement.rel = 'stylesheet';
            newLinkElement.id = 'theme-style';
            document.head.appendChild(newLinkElement);
        }
        // Set the href attribute of the link element to the theme CSS file
        linkElement.href = `${process.env.PUBLIC_URL}/Color-Themes/${themeName}-theme.css`;
    };

    const handleThemeChange = () => {
        setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
    };

    // Set up axios interceptor
    axios.interceptors.request.use(async config => {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            const token = await user.getIdToken(true);
            // console.log("User: ", user);  // Log the user
            // console.log("Token: ", token);  // Log the token
            config.headers.Authorization = `Bearer ${token}`;
        }
        //console.log("Request headers: ", config.headers);  // Log the request headers
        //console.log("Request headers auth:", config.headers.Authorization);  // Log the request headers

        return config;
    }, error => Promise.reject(error));

    return (
        <Router>
            <div className="App">

                <Routes>
                    <Route path="/auth" element={<AuthPage />} />
                    <Route path="/main" element={<MainPage />} />
                    <Route path="*" element={<RoundUpWelcomePage />} />
                    <Route path="/pundit" element={<ChatInterface userId={userId} />} /> {/* Passing userId as a prop */}
                </Routes>
                <button onClick={handleThemeChange}>
                    {theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
                </button>
                <div className="donation-section">
                    <p>If you are enjoying this app, please consider donating whatever you can. Even a $1 goes a long way. This entire system is being paid for and run by Sohrab out of pocket.</p>
                    <a className="donation-section-url" href="https://na01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fvenmo.com%2Fu%2FSorbe&data=05%7C01%7C%7C5d155bba6e264d7bf9c508db9a0e8ad8%7C84df9e7fe9f640afb435aaaaaaaaaaaa%7C1%7C0%7C638273159461933666%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=tUJ6yy6s0FH3CZn61LPrO%2F4sKUKWXqB%2FfnbpNiwPYKI%3D&reserved=0">
                        Click Here to Donate on Venmo
                    </a>
                </div>
                <a className="donation-section-url" href="https://cash.app/$sohrabseera">
                    Click Here to Donate on CashApp
                </a>
                <div className="donation-section">
                    <p>Disclaimer: The astrological guidance provided on this platform is intended for entertainment purposes only. It should not be construed as medical, legal, financial, or any other type of professional advice. While the platform aims to offer astrological wisdom, the advice given should not replace consultation with qualified professionals for specific concerns. The accuracy or reliability of the astrological advice is not guaranteed, and the platform and its operators disclaim any liability for the direct or indirect consequences of following any guidance provided herein.
                    </p>
                </div>
            </div>


        </Router>
    );
}

export default App;
